const tables = [
  {
    name: "Number",
  },
  {
    name: "Customer",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Billed By",
  },
  {
    name: "Delivery",
  },
  {
    name: "Payment Type",
  },
  {
    name: "Payment",
  },
  {
    name: "Total",
  },
  {
    name: "Action",
  },
];

export default tables;
